/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import { connect } from 'react-redux'

import type { TrafficFilterRulesetInfo } from '@modules/cloud-api/v1/types'
import type { AsyncRequestState } from '@modules/ui-types'

import { getTrafficFilterRulesets } from '@/reducers/trafficFilters'
import { createTrafficFilterRulesetAssociationRequest } from '@/reducers/asyncRequests/registry'

import { createRulesetAssociation } from '../../../../actions/trafficFilters'

import ApplyDeploymentTrafficFilterFlyout from './ApplyDeploymentTrafficFilterFlyout'

import type { ReduxState } from '@/types/redux'

type StateProps = {
  trafficFilterRulesets: TrafficFilterRulesetInfo[] | null
  createRulesetAssociationRequest: (rulesetId: string) => AsyncRequestState
}

type DispatchProps = {
  createRulesetAssociation: (rulesetId: string) => Promise<void>
}

type ConsumerProps = {
  regionId: string
  deploymentId: string
  onClose: () => void
}

const mapStateToProps = (
  state: ReduxState,
  { deploymentId, regionId }: ConsumerProps,
): StateProps => ({
  trafficFilterRulesets: getTrafficFilterRulesets(state, regionId),
  createRulesetAssociationRequest: (rulesetId: string) =>
    createTrafficFilterRulesetAssociationRequest(state, deploymentId, regionId, rulesetId),
})

const mapDispatchToProps = (
  dispatch,
  { regionId, deploymentId }: ConsumerProps,
): DispatchProps => ({
  createRulesetAssociation: (rulesetId: string) =>
    dispatch(
      createRulesetAssociation({
        regionId,
        rulesetId,
        associatedEntityId: deploymentId,
      }),
    ),
})

export default connect<StateProps, DispatchProps, ConsumerProps>(
  mapStateToProps,
  mapDispatchToProps,
)(ApplyDeploymentTrafficFilterFlyout)
